module.exports = __webpack_public_path__ + "static/media/tn.34dba63b.svg";